import classNames from 'classnames';
import Loading from '../../../../../../../components/common/Loading/Loading';
import React from 'react';
import Information, { InformationType } from '../../../../../../../components/envago/Information/Information';

interface CameraOverlayProps {
    loading: boolean;
    loadingText: string;
    callToActionText?: string;
    // meterNumber?: string; // to resolve a custom overlay mask later
}

const CameraOverlay = ({ loading, loadingText, callToActionText }: CameraOverlayProps) => {
    return (
        <>
            <div // top
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '12%',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    pointerEvents: 'none',
                }}
            >
                {callToActionText && (
                    <div className={'relative h-full z-50'}>
                        <div className={'absolute left-2 right-2 top-4'}>
                            <Information showIcon={false} type={InformationType.INFO}>
                                <div className={'text-center w-full text-sm'}>{callToActionText}</div>
                            </Information>
                        </div>
                    </div>
                )}
            </div>
            <div // bottom
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '16%',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    pointerEvents: 'none',
                }}
            />
            <div // left
                style={{
                    position: 'absolute',
                    top: '12%',
                    bottom: '16%',
                    left: 0,
                    width: '2%',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    pointerEvents: 'none',
                }}
            />
            <div // right
                style={{
                    position: 'absolute',
                    top: '12%',
                    bottom: '16%',
                    right: 0,
                    width: '2%',
                    backgroundColor: 'rgba(0,0,0,0.4)',
                    pointerEvents: 'none',
                }}
            />
            <div
                className={classNames('target-area', {
                    'target-area-loading': loading,
                })}
            >
                {loading && (
                    <div className={'relative flex justify-center items-center h-full w-full text-white'}>
                        <Loading text={loadingText} showSpinner={false} />
                    </div>
                )}
            </div>
        </>
    );
};

export default CameraOverlay;
